import React from 'react';
import PropTypes from 'prop-types';
import { Type } from 'react-spark';
import { CheckCircleIcon } from '../../icons';
import { FONT_SIZES } from '../../../../utils/novaTypography';

export const OffersV3DiscountAlert = ({ children, isVisible = true }) => {
    if (!isVisible) {
        return null;
    }

    return (
        <div className="sprk-u-mts" style={{ 
            backgroundColor: '#EFF7F3',
            borderRadius: '16px',
            boxShadow: '0 10px 20px 0 rgba(0, 0, 0, 0.02)',
            padding: '20px',
            display: 'flex',
            alignItems: 'flex-start',
        }}>
            <CheckCircleIcon width="2.5em" style={{ marginRight: '16px' }} />
            <Type.BodyFour className='sprk-u-mvn' style={{ fontSize: FONT_SIZES.small, lineHeight: 1.5 }}>
                {children}
            </Type.BodyFour>
        </div>
    );
};

OffersV3DiscountAlert.propTypes = {
    children: PropTypes.node.isRequired,
    isVisible: PropTypes.bool,
};

OffersV3DiscountAlert.defaultProps = {
    isVisible: true,
};
